<mat-dialog-content class="mat-typography">
    <h2>Ajout d'un type d'équipement</h2>  
    <form class="flex flex-col w-full" [formGroup]="typeEquipementForm" (ngSubmit)="onFormSubmit()">
        <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
            <mat-form-field class="w-full">
                <mat-label>Nom</mat-label>
                <input type="text" matInput formControlName="nom">
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
